import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { useEffect } from 'react';

import { type QueryStateSchema, backwardsCompatabilityFactory, queryParam, queryStateParser } from './queryStateParser';

const QS_KEY = 'paneDocumentRequestUserFileId';
const QS_TYPE: QueryStateSchema['type'] = 'documentRequestUserFile';

export const useOpenDocumentRequestUserFilePane = (): ((args: { documentRequestUserFileId: string }) => void) => {
  const [documentRequestUserFileIdDeprecated, setDocumentRequestUserFileId] = useQueryState(QS_KEY, {
    history: 'push',
  });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (documentRequestUserFileIdDeprecated) {
      setDocumentRequestUserFileId(null);
      setState(backwardsCompatabilityFactory({ id: documentRequestUserFileIdDeprecated, type: QS_TYPE }));
    }
  }, [documentRequestUserFileIdDeprecated]);

  return ({ documentRequestUserFileId }) => {
    setState((prevState) => {
      if (prevState?.some((entry) => entry.type === QS_TYPE && entry.id === documentRequestUserFileId)) {
        return prevState;
      }
      return [...(prevState || []), { id: documentRequestUserFileId, key: nanoid(), type: QS_TYPE }];
    });
  };
};
